import {
  MRT_Cell,
  MRT_Column,
  MRT_Row,
  MRT_TableInstance,
} from "material-react-table";
import { useEffect, useState } from "react";
import { Personnage } from "../../model/Personnage";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { Tag } from "../../model/Tag";

interface TagSelectorProps {
  cell: MRT_Cell<Personnage, unknown>;
  column: MRT_Column<Personnage, unknown>;
  row: MRT_Row<Personnage>;
  table: MRT_TableInstance<Personnage>;
  availableRoles: Array<Tag>;
}

const TagSelector = ({
  cell,
  column,
  row,
  table,
  availableRoles,
}: TagSelectorProps) => {
  const [tagValues, setTagsValues] = useState(() =>
    cell.getValue<Array<Tag>>().map((tag: Tag) => tag.id)
  );

  return (
    <Box>
      <FormControl variant="standard" sx={{ width: "100%" }}>
        <InputLabel id="tag-selector-label">Rôles</InputLabel>
        <Select
          labelId="tag-selector-label"
          id="demo-multiple-chip"
          multiple
          variant="standard"
          value={tagValues}
          onBlur={(event: any) => {
            var isCreating = table.getState().creatingRow?.id === row.id;
            var isEditing = table.getState().editingRow?.id === row.id;
            row._valuesCache[column.id] = event.target.value;
            if (isCreating) {
              table.setCreatingRow(row);
            } else if (isEditing) {
              table.setEditingRow(row);
            }
          }}
          onChange={(event: any) => {
            setTagsValues(event.target.value);
          }}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => {
                const role = availableRoles.filter((x) => x.id === value)[0];
                return (
                  <Chip
                    key={value}
                    label={role?.nom}
                    sx={{ backgroundColor: role?.color }}
                  />
                );
              })}
            </Box>
          )}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 150,
                width: 250,
              },
            },
          }}
        >
          {availableRoles.map((role) => (
            <MenuItem key={role.id} value={role.id}>
              {role.nom}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TagSelector;
